module.exports = __webpack_public_path__ + "img/鼠标滚轮缩放.0f995bfd.png";